import { render, staticRenderFns } from "./luottohakemus.vue?vue&type=template&id=48b5a2f4&"
import script from "./luottohakemus.vue?vue&type=script&lang=js&"
export * from "./luottohakemus.vue?vue&type=script&lang=js&"
import style0 from "./luottohakemus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports